<ng-container *ngIf="form" [formGroup]="form">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Select Blackout Dates</ion-card-title>
      <div class="optional-rift-soft">Recommended</div>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <h4>Select any dates that are unavailable for bookings.</h4>
        <div class="landowner-center accordion">
          <div class="landowner-wrapper">
            <div class="cnt-button listing">
              <div (click)="addBlackoutDay()" class="cnt-button-copy">Add Blackout Day(s)</div>
            </div>
            <div class="cnt-button">
              <div (click)="addBlackoutMonth()" class="cnt-button-copy">Add Blackout Month(s)</div>
            </div>
            <div class="cnt-button">
              <div (click)="addBlackoutDayOfWeek()" class="cnt-button-copy">Add Blackout Day of the Week</div>
            </div>
          </div>
        </div>
        <ng-container *ngFor="let blackoutDay of blackoutDays?.controls; trackBy: blackoutTrackBy(); let i = index">
          <div class="divider-line"></div>
          <curbnturf-blackout-selector
            [dateRange]="blackoutDay.value"
            (update)="blackoutUpdated($event, i)"
            (remove)="blackoutRemove(i)"
          >
          </curbnturf-blackout-selector>
        </ng-container>

        <div *ngIf="blackoutMonths?.controls.length > 0">
          <div class="divider-line"></div>
          <h2>Blackout Months</h2>
          <ng-container *ngFor="let blackoutMonth of blackoutMonths?.controls; let i = index">
            <div class="_1up-outer-wrapper" *ngIf="blackoutMonth.value">
              <div class="_1up-wrapper">
                <div class="month-blackout-outer flex-left">
                  <div class="blackout-month-label">
                    {{ months[blackoutMonth.value - 1].label }}
                  </div>
                  <div (click)="blackoutMonthRemove(i)" class="icon-trash-wrapper">
                    <div class="html-embed w-embed">
                      <curbnturf-misc-svg icon="trash"></curbnturf-misc-svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="!blackoutMonth.value">
              <div class="divider-line"></div>
              <div class="_1up-outer-wrapper">
                <div class="_1up-wrapper">
                  <div class="month-blackout-outer">
                    <label for="blackoutMonth" class="sr-only"> Blackout Month </label>
                    <ng-select
                      [formControl]="blackoutMonth"
                      [clearable]="false"
                      placeholder="Select"
                      id="blackoutMonth"
                      class="dropdown listing w-dropdown dropdown-toggle"
                      (open)="blackoutOpen = true"
                      (close)="blackoutOpen = false"
                    >
                      <ng-option *ngFor="let item of availableMonths" [value]="item.unit">
                        {{ item.label }}
                      </ng-option>
                    </ng-select>
                    <div (click)="blackoutMonthRemove(i)" class="icon-trash-wrapper">
                      <div class="html-embed w-embed">
                        <curbnturf-misc-svg icon="trash"></curbnturf-misc-svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dropdown-spacer" *ngIf="blackoutOpen">&nbsp;</div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div *ngIf="blackoutDayOfWeek?.controls.length > 0">
          <div class="divider-line"></div>
          <h2>Blackout Day of the Week</h2>
          <p>The days of the week listed below will not be available for booking.</p>
          <ng-container *ngFor="let blackoutDayOfWeek of blackoutDayOfWeek?.controls; let i = index">
            <div class="_1up-outer-wrapper" *ngIf="blackoutDayOfWeek.value">
              <div class="_1up-wrapper">
                <div class="month-blackout-outer flex-left">
                  <div class="blackout-month-label">
                    {{ blackoutDayOfWeek.value }}
                  </div>
                  <div (click)="blackoutDayOfWeekRemove(i)" class="icon-trash-wrapper">
                    <div class="html-embed w-embed">
                      <curbnturf-misc-svg icon="trash"></curbnturf-misc-svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="!blackoutDayOfWeek.value">
              <div class="divider-line"></div>
              <div class="_1up-outer-wrapper">
                <div class="_1up-wrapper">
                  <div class="month-blackout-outer">
                    <label for="blackoutDayOfWeek" class="sr-only"> Blackout Day of the Week </label>
                    <ng-select
                      [formControl]="blackoutDayOfWeek"
                      [clearable]="false"
                      placeholder="Select"
                      id="blackoutDayOfWeek"
                      class="dropdown listing w-dropdown dropdown-toggle"
                      (open)="blackoutOpen = true"
                      (close)="blackoutOpen = false"
                    >
                      <ng-option *ngFor="let item of availableDaysOfWeek" [value]="item">
                        {{ item }}
                      </ng-option>
                    </ng-select>
                    <div (click)="blackoutDayOfWeekRemove(i)" class="icon-trash-wrapper">
                      <div class="html-embed w-embed">
                        <curbnturf-misc-svg icon="trash"></curbnturf-misc-svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dropdown-spacer" *ngIf="blackoutOpen">&nbsp;</div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</ng-container>
